<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header">{{newDocument.titleHeader}}</span>
  </div>
  <!-- Contenedor -->
     <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      @if(newDocument.showTemplates){
        <field-type-switch [field]="{label: newDocument.pillTemplate}"
          [small]="true"
          [preSelectItem]="newDocument.showFormat"
          [disabled]="!newDocument.templates.length"
          (itemSelected)="changeShowFormat($event)">
        </field-type-switch>
      }
      @if(newDocument.showFormat){
        <field-type-list-simple [field]="newDocument.templateFieldInfo"
          [listValues]="newDocument.templates"
          [preSelectItem]="newDocument.templateId"
          [orderBy]="'text'"
          (itemSelected)="itemSelectedOn($event, 'templateId')">
        </field-type-list-simple>
      }@else {
        <field-type-list-simple [field]="newDocument.productFieldInfo"
          [listValues]="newDocument.formats"
          [preSelectItem]="newDocument.formatId"
          (itemSelected)="itemSelectedOn($event, 'formatId')">
        </field-type-list-simple>
      }
      <field-type-text-simple [field]="newDocument.nameFieldInfo"
        [preSelectItem]="newDocument.document.name"
        (itemSelected)="itemName($event)">
      </field-type-text-simple>
      @if (type === 'process-modal' || (type === 'documentation-list' && listSelect.length)) {
        <field-type-list-simple
          [field]="newDocument.processSteps"
          [listValues]="listSelect"
          [preSelectItem]="newDocument.stateId"
          (itemSelected)="itemSelectedList($event, 'stateId')">
        </field-type-list-simple>
      }
      @if (type === 'task') {
        <field-type-text-multiline [field]="newDocument.addCommentField"
          [preSelectItem]="newDocument.comments"
          (itemSelected)="newDocument.comments = $event.newValue">
        </field-type-text-multiline>
      }
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="validateForm()">
      <span class="common-button__text-title"
        [afTranslate]="'common.create'">Crear</span>
    </button>
  </div>
</div>
